export default "__VITE_ASSET__NSygTZuJ__"